import { initISWSideEffect } from "../../shared/components/isw-side-effects/create-isw-helpers";
import { OrvVergelijkenModalType } from "../infra/orv-schema";

export const syncOrvVergelijkenModalSideEffects = initISWSideEffect<OrvVergelijkenModalType>(({ has, draft }): void => {
  if (has.verzekerden.changed || has.verzekering.changed) {
    draft.dataOutdated = true;
  }
})();
